import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'notificationRound',

})
export class NotificationRoundPipe implements PipeTransform {

    transform(count: number): string {
        if (count && count > 99) {
            return '99+';
        } else {
            return count.toString();
        }
    }
}
